import { render, staticRenderFns } from "./ServicesBlock.vue?vue&type=template&id=3648a048&"
import script from "./ServicesBlock.vue?vue&type=script&lang=js&"
export * from "./ServicesBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports